
import { mapState } from "vuex"

import pageMixin from "@/mixins/pageMixin"
import BasicPage from "@/components/BasicPage"

export default {
  components: {
    BasicPage
  },
  mixins: [pageMixin],
  asyncData({ $storyblokHelper }) {
    return $storyblokHelper.get({ id: "unhappy" })
  },
  computed: {
    ...mapState({
      featureData: state => state.userStatus.featureData,
      userStatus: state => state.userStatus.userStatus
    })
  }
}
